import { LocaleMessages } from 'vue-i18n';
import base from './base';
import extended from './extended';

export default { de: { ...base, ...extended } } as LocaleMessages;
